import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import resolvePath from 'object-resolve-path';
import _ from 'underscore';
import $ from 'jquery';
import MapboxGeocoder from 'mapbox-gl-geocoder';
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions';

import CustomCategoryControl from './controls/CustomCategoryControl';
import CustomLayerControl from './controls/CustomLayerControl';

import { selectGeometry, selectPopupEditGeometry } from '../actions/actions_map';
import { changeZoom, changeCenter, changePitch, changeControl, changeBearing, changeStyle, changeMapData, changeMapCategories, changeDirectionsPrefill, changeMapLayersFilters } from '../actions/index';

mapboxgl.accessToken = $('#wp_mapbox_gl_js_access_token').val();

class Map extends Component {

  constructor(props) {
    super(props);
    this.state = {
      map : false,
      mapType : '',
      currentMarkers : [],
      mapObject : {},
      pointSource : false,
      fillLayer : false,
      lineLayer : false,
      markers : [],
      geocoderControl : false,
      navControl : false,
      scaleControl : false,
      fullscreenControl : false,
      directionsControl : false,
      customCategoryControl : false,
      customLayerControl : false,
      popup : false,
      dataAdded : false,
      drawingDirections : '',
      scrollZoom: true,
      loadedIcons: [],
      directionsPrefill: {
        origin: [], // [lat, lng]
        destination: [] // [lat, lng]
      },
      geolocaterControl: false
    }
  }

  // Every time state updates the geoJSON, it should be printed into the external input

  componentDidMount() {
    var map = new mapboxgl.Map({
      container: 'wp_mapbox_gl_js_map',
      style: this.props.mapObject.style,
      center : this.props.mapObject.center,
      zoom : this.props.mapObject.zoom,
      pitch : this.props.mapObject.pitch,
      bearing : this.props.mapObject.bearing
    });
    $('#wp-mapbox-gl-js-center').val(this.props.mapObject.center.join());
    $('#wp-mapbox-gl-js-pitch').val(this.props.mapObject.pitch);
    $('#wp-mapbox-gl-js-bearing').val(this.props.mapObject.bearing);
    $('#wp-mapbox-gl-js-zoom').val(this.props.mapObject.zoom);

    this.setState({mapObject:this.props.mapObject});

    map.on('load',function() {
      this.componentWillReceiveProps(this.props,'first');
      var oneOfDefaultStyles = false;
      var that = this;
      $('#wp-mapbox-gl-js-style option').each(function() {
        if(that.props.mapObject.style===$(this).val()) {
          oneOfDefaultStyles = true;
        }
      });
      if(!oneOfDefaultStyles) {
        $('#wp-mapbox-gl-js-custom-style').val(this.props.mapObject.style);
      } else {
        $('#wp-mapbox-gl-js-style').val(this.props.mapObject.style);
      }
    }.bind(this));

    map.on('style.load',function() {

      this.componentWillReceiveProps(this.props,'load');

      // Geocoder for the autocomplete
      if(!this.state.geocoderLoaded) {
        var geocoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          placeholder : 'Add marker by address...'
        });
        geocoder.on('result',function(e) {
          var found = false;
          this.props.mapObject.mapData.forEach(function(feature) {
            if(feature.id === e.result.center.join(',')) {
              found = true;
            }
          })
          if(!found) {
            var thisFeature = [{
              "type" : "Feature",
              "id" : e.result.center.join(','),
              "geometry" : {
                "type" : "Point",
                "coordinates" : e.result.center
              },
              "properties" : {}
            }]
            if(typeof thisFeature[0].properties.name === 'undefined') {
              thisFeature[0].properties.name = "";
              thisFeature[0].properties.description = "Description";
              thisFeature[0].properties.color = "#333";
              thisFeature[0].properties.marker_icon_url = $('#wp_mapbox_gl_js_plugin_url').val()+"/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/black_default.png";
              thisFeature[0].properties.marker_icon_anchor = "bottom";
              thisFeature[0].properties.marker_title = "Marker";
              thisFeature[0].properties.category = "";
              if(thisFeature[0].geometry.type==='Polygon') {
                thisFeature[0].properties.marker_title = 'Fill';
              }
              if(thisFeature[0].geometry.type==='LineString') {
                thisFeature[0].properties.marker_title = 'Line';
              }
              var existingFeatures = JSON.parse(JSON.stringify(this.props.mapObject.mapData));
              existingFeatures = existingFeatures.concat(thisFeature);
              this.props.dispatch(changeMapData(existingFeatures));
            }
          }
        }.bind(this));
        document.getElementById('wp-mapbox-gl-js-autocomplete').innerHTML = '';
        document.getElementById('wp-mapbox-gl-js-autocomplete').appendChild(geocoder.onAdd(map));
        $(document).on('click','.geocoder-icon geocoder-icon-close',function(e) { e.preventDefault() });
        this.setState({geocoderLoaded:true});
      }

    }.bind(this));

    // var Draw = new MapboxDraw({
    //   controls : {
    //     combine_features : false,
    //     uncombine_features : false,
    //     trash : false
    //   },
    //   styles: [{'id': 'gl-draw-polygon-fill-inactive','type': 'fill','filter': ['all',['==', 'active', 'false'],['==', '$type', 'Polygon'],['!=', 'mode', 'static']],'paint': {'fill-color': '#3bb2d0','fill-outline-color': '#3bb2d0','fill-opacity': 0.1}},{'id': 'gl-draw-polygon-fill-active','type': 'fill','filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],'paint': {'fill-color': '#fbb03b','fill-outline-color': '#fbb03b','fill-opacity': 0.1}},{'id': 'gl-draw-polygon-midpoint','type': 'circle','filter': ['all',['==', '$type', 'Point'],['==', 'meta', 'midpoint']],'paint': {'circle-radius': 3,'circle-color': '#fbb03b'}},{'id': 'gl-draw-polygon-stroke-inactive','type': 'line','filter': ['all',['==', 'active', 'false'],['==', '$type', 'Polygon'],['!=', 'mode', 'static']],'layout': {'line-cap': 'round','line-join': 'round'},'paint': {'line-color': '#3bb2d0','line-width': 0}},{'id': 'gl-draw-polygon-stroke-active','type': 'line','filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],'layout': {'line-cap': 'round','line-join': 'round'},'paint': {'line-color': '#fbb03b','line-dasharray': [0.2, 2],'line-width': 2}},{'id': 'gl-draw-line-inactive','type': 'line','filter': ['all',['==', 'active', 'false'],['==', '$type', 'LineString'],['!=', 'mode', 'static']],'layout': {'line-cap': 'round','line-join': 'round'},'paint': {'line-color': '#3bb2d0','line-width': 0}},{'id': 'gl-draw-line-active','type': 'line','filter': ['all',['==', '$type', 'LineString'],['==', 'active', 'true']],'layout': {'line-cap': 'round','line-join': 'round'},'paint': {'line-color': '#fbb03b','line-dasharray': [0.2, 2],'line-width': 2}},{'id': 'gl-draw-polygon-and-line-vertex-stroke-inactive','type': 'circle','filter': ['all',['==', 'meta', 'vertex'],['==', '$type', 'Point'],['!=', 'mode', 'static']],'paint': {'circle-radius': 5,'circle-color': '#fff'}},{'id': 'gl-draw-polygon-and-line-vertex-inactive','type': 'circle','filter': ['all',['==', 'meta', 'vertex'],['==', '$type', 'Point'],['!=', 'mode', 'static']],'paint': {'circle-radius': 3,'circle-color': '#fbb03b'}},{'id': 'gl-draw-point-point-stroke-inactive','type': 'circle','filter': ['all',['==', 'active', 'false'],['==', '$type', 'Point'],['==', 'meta', 'feature'],['!=', 'mode', 'static']],'paint': {'circle-radius': 0,'circle-opacity': 1,'circle-color': '#fff'}},{'id': 'gl-draw-point-inactive','type': 'circle','filter': ['all',['==', 'active', 'false'],['==', '$type', 'Point'],['==', 'meta', 'feature'],['!=', 'mode', 'static']],'paint': {'circle-radius': 0,'circle-color': '#3bb2d0'}},{'id': 'gl-draw-point-stroke-active','type': 'circle','filter': ['all',['==', '$type', 'Point'],['==', 'active', 'true'],['!=', 'meta', 'midpoint']],'paint': {'circle-radius': 0,'circle-color': '#fff'}},{'id': 'gl-draw-point-active','type': 'circle','filter': ['all',['==', '$type', 'Point'],['!=', 'meta', 'midpoint'],['==', 'active', 'true']],'paint': {'circle-radius': 0,'circle-color': '#fbb03b'}},{'id': 'gl-draw-polygon-fill-static','type': 'fill','filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],'paint': {'fill-color': '#404040','fill-outline-color': '#404040','fill-opacity': 0.1}},{'id': 'gl-draw-polygon-stroke-static','type': 'line','filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],'layout': {'line-cap': 'round','line-join': 'round'},'paint': {'line-color': '#404040','line-width': 2}},{'id': 'gl-draw-line-static','type': 'line','filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'LineString']],'layout': {'line-cap': 'round','line-join': 'round'},'paint': {'line-color': '#404040','line-width': 2}},{'id': 'gl-draw-point-static','type': 'circle','filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],'paint': {'circle-radius': 0,'circle-color': '#404040'}}]});

    /* MapboxDraw is in src/components/App.js now */
    const Draw = this.props.Draw;

    map.addControl(Draw,'top-right')
    $('.mapboxgl-ctrl-top-right .mapboxgl-ctrl').addClass('wp-mapbox-gl-js-custom-draw-controls');
    $('.wp-mapbox-gl-js-custom-draw-controls').appendTo('.mapboxgl-control-container');
    // $('.wp-mapbox-gl-js-custom-draw-controls button').hide();
    // $('.wp-mapbox-gl-js-custom-draw-controls').append('<div class="wp-mapbox-gl-js-show-editor"><p><small>Add shapes or points!</small></p></div>');
    // $(document).on('click','.wp-mapbox-gl-js-show-editor',function() {
    //   $('.wp-mapbox-gl-js-custom-draw-controls button').show();
    //   $('.wp-mapbox-gl-js-show-editor').hide();
    // });

    // Add existing features
    var featureCollection = {
      "type" : "FeatureCollection",
      "features" : this.props.mapObject.mapData
    }
    Draw.add(featureCollection);

    // Set up events
    map.on('draw.create', function (e) {
      // console.log(e.features);
      var existingFeatures = JSON.parse(JSON.stringify(this.props.mapObject.mapData));
      existingFeatures = existingFeatures.concat(e.features);
      var newFeatures = [];
      existingFeatures.forEach(function(feature,index) {
        var thisFeature = JSON.parse(JSON.stringify(feature));
        if(typeof thisFeature.properties.name === 'undefined') {
          thisFeature.properties.name = "";
          thisFeature.properties.description = "Description";
          thisFeature.properties.color = "#333";
          thisFeature.properties.marker_icon_url = $('#wp_mapbox_gl_js_plugin_url').val()+"/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/black_default.png";
          thisFeature.properties.marker_title = "Marker";
          thisFeature.properties.category = "";
          thisFeature.properties.popup_open = true;
          thisFeature.properties.opacity = 0.4;
          thisFeature.properties.marker_icon_anchor = "bottom";
          if(thisFeature.geometry.type==='Polygon') {
            thisFeature.properties.marker_title = 'Fill';
          }
          if(thisFeature.geometry.type==='LineString') {
            thisFeature.properties.marker_title = 'Line';
          }
        }
        newFeatures.push(thisFeature);
      })
      this.props.dispatch(changeMapData(newFeatures));
      this.props.dispatch(selectGeometry(e.features[0].id));

    }.bind(this));

    // map.on('draw.delete', function (e) {
    //   // console.log(e.features);
    //   var existingFeatures = JSON.parse(JSON.stringify(this.props.mapObject.mapData));
    //   map.removeSource(e.features[0].id);
    //   map.removeLayer(e.features[0].id);
    //   existingFeatures = existingFeatures.filter(feature => {
    //     return feature.id!==e.features[0].id;
    //   });
    //   this.props.dispatch(changeMapData(existingFeatures));
    // }.bind(this));

    map.on('draw.modechange', function (e) {
      if(e.mode==='draw_line_string') {
        this.setState({drawingDirections:'Click twice on the last point to end your <strong>line</strong>.'})
      } else if(e.mode==='draw_polygon') {
        this.setState({drawingDirections:'To finish your fill / polygon, click the first <strong>point</strong>.'})
      } else if(e.mode === 'draw_point') {
        this.setState({ drawingDirections: 'Click anywhere on the map to place a <strong>marker</strong>.' });
      } else {
        this.setState({drawingDirections: ''})
      }
    }.bind(this));

    map.on('draw.update', function (e) {
      var existingFeatures = JSON.parse(JSON.stringify(this.props.mapObject.mapData));
      existingFeatures = existingFeatures.map(feature => {
        var thisFeature = false;
        if(feature.id===e.features[0].id) {
          thisFeature = e.features[0];
          thisFeature.properties = feature.properties;

          if (typeof feature.fillType === 'string') {
            thisFeature.fillType = feature.fillType;
          }
        } else {
          thisFeature = feature;
        }
        return thisFeature;
      });
      this.props.dispatch(changeMapData(existingFeatures));
    }.bind(this));

    var that = this;
    $(document).on('click','#changePopupContent',function(e) {
      e.preventDefault();
      var featureID = $(this).data('featureid');
      that.props.dispatch(selectPopupEditGeometry(featureID));
    })
    $(document).on('click','#wp_mapbox_gl_js_set_directions',function(e) {
      // This one is on the map
      e.preventDefault();
      // var featureID = $(this).data('featureId');
      var coords = $(this).data('lngLat').split(',');
      var lngLat = [parseFloat(coords[0]), parseFloat(coords[1])];

      if (that.state.directionsControl) {
        that.state.directionsControl.setDestination(lngLat);
      } else {
        alert('You must enable the Directions checkbox on the right for the Directions button to work.');
      }
    });
    $(document).on('click','#deleteFeature, #deleteFeatureFromPopup, #make-3d, #make-2d', function(e) {
      e.preventDefault();
      var featureID = $(this).data('featureid');
      var existingFeatures = JSON.parse(JSON.stringify(that.props.mapObject.mapData));
      Draw.delete(featureID);
      map.removeLayer(featureID);
      map.removeSource(featureID);
      existingFeatures = existingFeatures.filter(feature => {
        return feature.id!==featureID;
      });
      if(that.state.popup) {
        that.state.popup.remove();
      }

      that.props.dispatch(selectGeometry(false))
      that.props.dispatch(selectPopupEditGeometry(false));
      that.props.dispatch(changeMapData(existingFeatures));

      // Select new feature
      if (e.target.id === 'make-3d' || e.target.id === 'make-2d') {
        const newFeatureId = existingFeatures.filter((feature) => {
          return feature.prevId === featureID;
        })[0];
        that.props.dispatch(selectGeometry(newFeatureId.id))
      }
    });
    // Dataset feature of setting ID to feature that exists
  	$(document).on('click', '#set_wp_mapbox_gl_js_feature', function(e) {
      e.preventDefault();
  		if($('#wp_mapbox_gl_js_feature_list').val()!==''&&this.props.mapObject.mapData.length===1) {
        var newMapData = JSON.parse(JSON.stringify(this.props.mapObject.mapData));
        // Deletion
        Draw.delete(newMapData[0].id);
        map.removeLayer(newMapData[0].id);
        map.removeSource(newMapData[0].id);
        if(this.state.popup) {
          this.state.popup.remove();
        }
        this.props.dispatch(selectGeometry(false))
        this.props.dispatch(selectPopupEditGeometry(false));
        this.props.dispatch(changeMapData([]));
        // Re-adding
        var that = this;
        newMapData[0].id = $('#wp_mapbox_gl_js_feature_list').val();
        setTimeout(function() {
          Draw.add(newMapData[0]);
          that.props.dispatch(changeMapData(newMapData));
          $('.wp_mapbox_gl_js_dataset_error').html('Success! Please publish or update this post.');
        },1000);
  		} else {
        $('.wp_mapbox_gl_js_dataset_error').html('Either you did not select a feature or this post has more than one feature to associate. See the documentation for help.');
      }
  	}.bind(this));
    $(document).on('change','#wp-mapbox-gl-js-style',function(e) {
      this.props.dispatch(changeStyle(e.target.value));
    }.bind(this));
    $(document).on('change','#wp-mapbox-gl-js-custom-style',function(e) {
      if(e.target.value!=='') {
        this.props.dispatch(changeStyle(e.target.value));
      }
    }.bind(this));
    $(document).on('change','#wp-mapbox-gl-js-center',function(e) {
      var array = e.target.value.split(',');
      array[0] = parseFloat(array[0]);
      array[1] = parseFloat(array[1]);
      this.props.dispatch(changeCenter(array));
    }.bind(this));
    $(document).on('change','#wp-mapbox-gl-js-zoom',function(e) {
      this.props.dispatch(changeZoom(e.target.value));
    }.bind(this));
    $(document).on('change','#wp-mapbox-gl-js-bearing',function(e) {
      this.props.dispatch(changeBearing(e.target.value));
    }.bind(this));
    $(document).on('change','#wp-mapbox-gl-js-pitch',function(e) {
      this.props.dispatch(changePitch(e.target.value));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_scroll_zoom',function(e) {
      this.props.dispatch(changeControl(e.target.checked, 'scrollZoom'));
    }.bind(this));

    $(document).on('change','#wp_mapbox_gl_js_location_search',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'geocoder'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_distance',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'scale'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_zoompan',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'navigation'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_fullscreen',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'fullscreen'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_directions',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'directions'));
      this.props.dispatch(changeControl(false,'preFillInput'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_category_filter',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'categoryFilter'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_layer_filter',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'layerFilter'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_layer_select',function(e) {
      this.props.dispatch(changeMapLayersFilters($('#wp_mapbox_gl_js_layer_select').val(),'layerFilter'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_directions_pre_fill_input',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'preFillInput'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_controls_geolocater',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'geolocaterControl'));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_location_sidebar',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'locationSidebar'));
    }.bind(this));
    $(document).on('change','#wp-mapbox-gl-js-marker-overlap',function(e) {
      this.props.dispatch(changeControl(!e.target.checked,'markerNoDisappear'));
    }.bind(this));
    $(document).on('click','#wp-mapbox-gl-js-marker-hide',function(e) {
      e.preventDefault();
      var newFeatures = JSON.parse(JSON.stringify(this.props.mapObject.mapData))
      newFeatures.forEach(function(feature) {
        feature.properties.popup_open = false;
      })
      that.props.dispatch(changeMapData(newFeatures));
    }.bind(this));
    $(document).on('change','#wp_mapbox_gl_js_cluster_markers',function(e) {
      this.props.dispatch(changeControl(e.target.checked,'clusterMarkers'));
    }.bind(this));



    $('#category_filter_input_submit').on('click', function(e) {
      e.preventDefault();
      if($('#category_filter_input').val()!=='') {
        var newMapCategories = JSON.parse(JSON.stringify(this.props.mapObject.mapCategories));
        const newCategory = $('#category_filter_input').val();
        if(newMapCategories.indexOf(newCategory)===-1) {
          newMapCategories.push(newCategory);
          this.props.dispatch(changeMapCategories(newMapCategories));
          $('#category_filter_input').val('');
        }
      }
    }.bind(this));

    map.on('moveend',function() {
      if($('#wp-mapbox-gl-js-set-current-map-view')[0].checked) {
        $('#wp-mapbox-gl-js-zoom').val(map.getZoom().toFixed(4));
        $('#wp-mapbox-gl-js-pitch').val(map.getPitch().toFixed(4));
        $('#wp-mapbox-gl-js-bearing').val(map.getBearing().toFixed(4));
        $('#wp-mapbox-gl-js-center').val(map.getCenter().lng.toFixed(4)+','+map.getCenter().lat.toFixed(4));
        this.props.dispatch(changeCenter([map.getCenter().lng,map.getCenter().lat]));
        this.props.dispatch(changeZoom(map.getZoom()));
        this.props.dispatch(changePitch(map.getPitch()));
        this.props.dispatch(changeBearing(map.getBearing()));
      }
    }.bind(this))
    this.setState({map});

  }

  componentWillReceiveProps(nextProps,flag) {
    // console.log({ nextProps, thisProps: this.props })
    const { map } = this.state;
    var markers = [];

    // Controls
    if(map.loaded()) {
      if(nextProps.mapObject.controls.navigation&&!this.state.navControl) {
        var navControl = new mapboxgl.NavigationControl();
        map.addControl(navControl);
        this.setState({navControl:navControl})
        $('#wp_mapbox_gl_js_zoompan').prop('checked', true);
      } else if(!nextProps.mapObject.controls.navigation&&this.state.navControl) {
        map.removeControl(this.state.navControl)
        this.setState({navControl:false})
        $('#wp_mapbox_gl_js_zoompan').prop('checked', false);
      }

      if(nextProps.mapObject.controls.geocoder&&!this.state.geocoderControl) {
        var geocoder = new MapboxGeocoder({
            accessToken: mapboxgl.accessToken
        });
        map.addControl(geocoder,'top-left');
        this.setState({geocoderControl:geocoder})
        $('#wp_mapbox_gl_js_location_search').prop('checked', true);
      } else if(!nextProps.mapObject.controls.geocoder&&this.state.geocoderControl) {
        map.removeControl(this.state.geocoderControl);
        this.setState({geocoderControl:false})
        $('#wp_mapbox_gl_js_location_search').prop('checked', false);
      }

      if(nextProps.mapObject.controls.markerNoDisappear) {
        $('#wp-mapbox-gl-js-marker-overlap').prop('checked', false);
        nextProps.mapObject.mapData.forEach(function(feature) {
          if(feature.geometry.type==='Point') {
            if(map.getSource(feature.id)) {
              map.setLayoutProperty(feature.id,'icon-allow-overlap',true)
            }
          }
        })
      } else {
        $('#wp-mapbox-gl-js-marker-overlap').prop('checked', true);
        nextProps.mapObject.mapData.forEach(function(feature) {
          if(feature.geometry.type==='Point') {
            if(map.getSource(feature.id) && map.getLayer(feature.id)) {
              map.setLayoutProperty(feature.id,'icon-allow-overlap',false)
            }
          }
        })
      }

      if(nextProps.mapObject.controls.directions&&!this.state.directionsControl) {
        var directions = new MapboxDirections({
            accessToken: mapboxgl.accessToken,
            interactive: false
        });
        directions.on('origin',function(e) {
          var newPreFillInput = JSON.parse(JSON.stringify(this.props.mapObject.preFillDirections));
          newPreFillInput['origin'] = $('#mapbox-directions-origin-input input').val();
          // console.log(newPreFillInput)
          this.props.dispatch(changeDirectionsPrefill(newPreFillInput));
        }.bind(this)).on('destination', function(e) {
          var newPreFillInput = JSON.parse(JSON.stringify(this.props.mapObject.preFillDirections));
          newPreFillInput['destination'] = $('#mapbox-directions-destination-input input').val();
          this.props.dispatch(changeDirectionsPrefill(newPreFillInput));
        }.bind(this)).on('clear',function(e) {
          var newPreFillInput = JSON.parse(JSON.stringify(nextProps.mapObject.preFillDirections));
          newPreFillInput[e.type] = $('#mapbox-directions-'+e.type+'-input input').val();
          this.props.dispatch(changeDirectionsPrefill(newPreFillInput));
        }.bind(this));
        map.addControl(directions,'top-left');
        this.setState({ directionsControl: directions });
        $('#wp_mapbox_gl_js_directions').prop('checked', true);
        $('#wp_mapbox_gl_js_directions_pre_fill_checkbox').show();
        // console.log()
        if(nextProps.mapObject.preFillDirections.origin!==''||nextProps.mapObject.preFillDirections.destination!=='') {
          $('#wp_mapbox_gl_js_directions_pre_fill_checkbox input').prop('checked', true);
        }
      } else if(!nextProps.mapObject.controls.directions&&this.state.directionsControl) {
        map.removeControl(this.state.directionsControl);
        map.removeLayer('directions-route-line');
        map.removeLayer('directions-route-line-alt');
        map.removeLayer('directions-hover-point-casing');
        map.removeLayer('directions-hover-point');
        map.removeLayer('directions-waypoint-point-casing');
        map.removeLayer('directions-waypoint-point');
        map.removeLayer('directions-origin-point');
        map.removeLayer('directions-origin-label');
        map.removeLayer('directions-destination-point');
        map.removeLayer('directions-destination-label');
        if (map.getSource('directions')) map.removeSource('directions');
        this.setState({directionsControl:false})
        $('#wp_mapbox_gl_js_directions').prop('checked', false);
        $('#wp_mapbox_gl_js_directions_pre_fill_checkbox').hide();
      }

      if(nextProps.mapObject.controls.locationSidebar) {
        $('#wp_mapbox_gl_js_location_sidebar').prop('checked', true);
      } else {
        $('#wp_mapbox_gl_js_location_sidebar').prop('checked', false);
      }

      if(nextProps.mapObject.controls.clusterMarkers) {
        $('#wp_mapbox_gl_js_cluster_markers').prop('checked', true);
        var mapDataPoints = [];
        nextProps.mapObject.mapData.forEach(function(feature) {
          if(feature.geometry.type==='Point') {
            mapDataPoints.push(feature);
          }
        })
        var featureCollection = {
          type : "FeatureCollection",
          features : mapDataPoints
        }
        if(map.getSource('marker-cluster-geojson')) {
          map.getSource('marker-cluster-geojson').setData(featureCollection);
        } else {
          map.addSource('marker-cluster-geojson', {
            type: "geojson",
            data: featureCollection,
            cluster: true,
            clusterMaxZoom: 14,
            clusterRadius: 50
          })
          map.addLayer({
              id: "clusters",
              type: "circle",
              source: "marker-cluster-geojson",
              filter: ["has", "point_count"],
              paint: {
                  "circle-color": [ "step", ["get", "point_count"],
                      "#51bbd6", 100,
                      "#f1f075", 750,
                      "#f28cb1"
                  ],
                  "circle-radius": [ "step", ["get", "point_count"],
                      20, 100,
                      30, 750,
                      40
                  ]
              }
          });
          map.addLayer({
              id: "cluster-count",
              type: "symbol",
              source: "marker-cluster-geojson",
              filter: ["has", "point_count"],
              layout: {
                  "text-field": "{point_count_abbreviated}",
                  "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                  "text-size": 12
              }
          });
          map.addLayer({
              id: "unclustered-point",
              type: "symbol",
              source: "marker-cluster-geojson",
              filter: ["!", ["has", "point_count"]],
              layout : {
                "icon-image" : ["get", "marker_icon_url"],
                "icon-anchor" : ["get", "marker_icon_anchor"],
                'icon-size' : 0.2
              }
          });
          mapDataPoints.forEach(function(feature) {
            map.setPaintProperty(feature.id,'icon-opacity',0)
          })
          map.on('click','unclustered-point',function(e) {
            console.log(e);
            if(this.state.popup) {
              this.state.popup.remove();
            }
            if(e.features[0].geometry.type==='Point') {

              var popup = new mapboxgl.Popup({
                offset : 20
              })

              let popupHTML =
                '<div>'+
                  '<div>'+e.features[0].properties.description+'</div>'+
                '</div>';

              popup.setLngLat({lat: e.features[0].geometry.coordinates[1], lng: e.features[0].geometry.coordinates[0]})
                .setHTML(popupHTML).addTo(map);

              this.setState({popup})
            }
            this.props.dispatch(selectGeometry(e.features[0].layer.id))
          }.bind(this))
        }
      } else {
        // Hide the clustering layer or remove the source entirely
        $('#wp_mapbox_gl_js_cluster_markers').prop('checked', false);
        if(map.getSource('marker-cluster-geojson')) {
          map.removeLayer('unclustered-point');
          map.removeLayer('cluster-count');
          map.removeLayer('clusters');
          map.removeSource('marker-cluster-geojson');
          nextProps.mapObject.mapData.forEach(function(feature) {
            if(feature.geometry.type==='Point') {
              map.setPaintProperty(feature.id,'icon-opacity',1)
            }
          })
        }
      }

      // prefill input

      if(nextProps.mapObject.controls.scale&&!this.state.scaleControl) {
        var scale = new mapboxgl.ScaleControl({
          maxWidth: 80,
          unit: 'metric'
        })
        map.addControl(scale,'top-left');
        this.setState({scaleControl:scale})
        $('#wp_mapbox_gl_js_distance').prop('checked', true);
      } else if(!nextProps.mapObject.controls.scale&&this.state.scaleControl) {
        map.removeControl(this.state.scaleControl);
        this.setState({scaleControl:false})
        $('#wp_mapbox_gl_js_distance').prop('checked', false);
      }

      if(nextProps.mapObject.controls.fullscreen&&!this.state.fullscreenControl) {
        var fullscreen = new mapboxgl.FullscreenControl();
        map.addControl(fullscreen,'top-right');
        this.setState({fullscreenControl:fullscreen})
        $('#wp_mapbox_gl_js_fullscreen').prop('checked', true);
      } else if(!nextProps.mapObject.controls.fullscreen&&this.state.fullscreenControl) {
        map.removeControl(this.state.fullscreenControl);
        $('#wp_mapbox_gl_js_fullscreen').prop('checked', false);
        this.setState({fullscreenControl:false})
      }
    }

    // scroll zoom
    if (nextProps.mapObject.controls.scrollZoom) {
      map.scrollZoom.enable();
      $('#wp_mapbox_gl_js_scroll_zoom').prop('checked', true);
      this.setState({ scrollZoom: true });

    } else if (!nextProps.mapObject.controls.scrollZoom) {
      map.scrollZoom.disable();
      $('#wp_mapbox_gl_js_scroll_zoom').prop('checked', false);
      this.setState({ scrollZoom: false });
    }

    if(this.props.mapObject.style!==nextProps.mapObject.style) {
      map.setStyle(nextProps.mapObject.style);
    }

    // Layer filter
    if (nextProps.mapObject.controls.layerFilter && !this.state.customLayerControl) {
      $('#wp_mapbox_gl_js_layer_creator').show();
      $('#wp_mapbox_gl_js_layer_select').html('');
      map.getStyle().layers.forEach(function(layer) {
        if(layer.source==='composite') {
          $('#wp_mapbox_gl_js_layer_select').append('<option id="'+layer.id+'">'+layer.id+'</option>');
        }
      })
      // console.log(nextProps.mapObject.mapLayersFilter)
      const customLayerControl = new CustomLayerControl({
        layers : nextProps.mapObject.mapLayersFilter
      })
      map.addControl(customLayerControl,'top-left');
      this.setState({customLayerControl:customLayerControl})
      $('#wp_mapbox_gl_js_layer_filter').prop('checked', true);
    } else if (!nextProps.mapObject.controls.layerFilter && this.state.customLayerControl) {
      $('#wp_mapbox_gl_js_layer_creator').hide();
      map.removeControl(this.state.customLayerControl);
      this.setState({customLayerControl:false})
      $('#wp_mapbox_gl_js_layer_filter').prop('checked', false);
    }
    // If there is a change to selected layers to filter
    if(this.state.customLayerControl && !_.isEqual(nextProps.mapObject.mapLayersFilter,this.state.mapObject.mapLayersFilter)) {
      this.state.customLayerControl.updateLayers(nextProps.mapObject.mapLayersFilter);
    }

    // category filter
    if (nextProps.mapObject.controls.categoryFilter && !this.state.customCategoryControl) {
      $('#wp_mapbox_gl_js_category_creator').show();
      const customCategoryControl = new CustomCategoryControl({
        categories : nextProps.mapObject.mapCategories,
        mapData : nextProps.mapObject.mapData
      })
      map.addControl(customCategoryControl,'top-left');
      this.setState({customCategoryControl:customCategoryControl})
      $('#wp_mapbox_gl_js_category_filter').prop('checked', true);
    } else if (!nextProps.mapObject.controls.categoryFilter && this.state.customCategoryControl) {
      $('#wp_mapbox_gl_js_category_creator').hide();
      map.removeControl(this.state.customCategoryControl);
      this.setState({customCategoryControl:false})
      $('#wp_mapbox_gl_js_category_filter').prop('checked', false);
    }

    // geolocater
    if (nextProps.mapObject.controls.geolocaterControl && !this.state.geolocaterControl) {
      const geolocaterControl = new mapboxgl.GeolocateControl({
        positionOptions: { enableHighAccuracy: true },
        trackUserLocation: true
      });
      map.addControl(geolocaterControl);
      this.setState({ geolocaterControl: geolocaterControl });
      $('#wp_mapbox_gl_js_controls_geolocater').prop('checked', true);
    } else if (!nextProps.mapObject.controls.geolocaterControl && this.state.geolocaterControl) {
      if(this.state.geolocaterControl) {
        map.removeControl(this.state.geolocaterControl);
      }
      this.setState({ geolocaterControl: false });
      $('#wp_mapbox_gl_js_controls_geolocater').prop('checked', false);
    }

    // Update control's map data and categories if a change
    if(this.props.mapObject.mapCategories!==nextProps.mapObject.mapCategories && this.state.customCategoryControl) {
      this.state.customCategoryControl.updateCategories(nextProps.mapObject.mapCategories);
    }
    if(!_.isEqual(nextProps.mapObject.mapData, this.props.mapObject.mapData) && this.state.customCategoryControl) {
      this.state.customCategoryControl.updateMapData(nextProps.mapObject.mapData);
    }

    if($('.mapboxgl-popup').length>0) {
      console.log(this.props.mapObject)
      console.log($('.mapboxgl-popup').length);
      var that = this;
      $('.mapboxgl-popup').each(function() {
        $(this).find('.mapboxgl-popup-content').css('background-color',that.props.mapObject.popupStyle.backgroundColor)
          $(this).find('.mapboxgl-popup-content').css('border-color',that.props.mapObject.popupStyle.borderColor)
        $(this).find('.mapboxgl-popup-tip').css('border-top-color',that.props.mapObject.popupStyle.backgroundColor)
      })
    }

    // Set currently selected geometry popup
    if(nextProps.mapActions.selectGeometry&&nextProps.mapActions.selectGeometry!==this.props.mapActions.selectGeometry) {
        var popup = new mapboxgl.Popup({
          offset : 20
        })
        var thisFeature = false;
        nextProps.mapObject.mapData.forEach(function(feature) {
          if(feature.id===nextProps.mapActions.selectGeometry) {
            thisFeature = feature;
          }
        });

        if(this.state.popup) {
          this.state.popup.remove();
        }

        if(thisFeature && thisFeature.geometry.type==='Point') {
          let popupHTML =
            '<div>'+
              '<div>'+thisFeature.properties.description+'</div>'+
              '<div style="display:flex;margin-left:-7px;position:absolute;margin-top:50px;">'+
                '<button id="changePopupContent" class="button" data-featureid="'+thisFeature.id+'"><i class="dashicons dashicons-edit"></i></button>'+ '<br>' +
                '<button id="deleteFeatureFromPopup" class="button" data-featureid="'+thisFeature.id+'"><i class="dashicons dashicons-trash"></i></button>'+
              '</div>'+
            '</div>';

          popup.setLngLat({lat: thisFeature.geometry.coordinates[1], lng: thisFeature.geometry.coordinates[0]})
            .setHTML(popupHTML).addTo(map);

          this.setState({popup});
      }
    }

    // Handling custom map creation and editing
    if(nextProps.mapObject.mapType==='custom'&&(flag==='load'||(!_.isEqual(nextProps.mapObject.mapData,this.props.mapObject.mapData)&&nextProps.mapObject.mapData.length>0))) {
      // Update current open popup
      if(this.state.popup&&this.state.popup.isOpen()) {
        this.state.popup.remove();
        var thisFeature = false;
        nextProps.mapObject.mapData.forEach(function(feature) {
          if(feature.id===nextProps.mapActions.selectGeometry) {
            thisFeature = feature;
          }
        });
        var popup = new mapboxgl.Popup({
          offset : 20
        });
        if (thisFeature && thisFeature.geometry.type==='Point') {
          let popupHTML =
              '<div>'+
                '<div>'+thisFeature.properties.description+'</div>'+
                '<div style="display:flex;margin-left:-7px;position:absolute;margin-top:50px;">'+
                  '<button id="changePopupContent" class="button" data-featureid="'+thisFeature.id+'"><i class="dashicons dashicons-edit"></i></button>'+ '<br>' +
                  '<button id="deleteFeatureFromPopup" class="button" data-featureid="'+thisFeature.id+'"><i class="dashicons dashicons-trash"></i></button>'+
                '</div>'+
              '</div>';

          popup.setLngLat({lat: thisFeature.geometry.coordinates[1], lng: thisFeature.geometry.coordinates[0]})
            .setHTML(popupHTML).addTo(map);

          this.setState({popup})
        }
      }
      // Loop and add or modify data
      // console.log(nextProps.mapObject.mapData)
      nextProps.mapObject.mapData.forEach(function(feature,index) {
        var featureCollection = {
          "type" : "FeatureCollection",
          "features" : [feature]
        }
        // console.log(feature);
        // If only a marker icon or color or anchor has changed
        if(map.getSource(feature.id) && typeof this.props.mapObject.mapData[index] !== 'undefined' && (feature.properties.marker_icon_anchor!==this.props.mapObject.mapData[index].properties.marker_icon_anchor||feature.properties.marker_icon_url!==this.props.mapObject.mapData[index].properties.marker_icon_url||feature.properties.color!==this.props.mapObject.mapData[index].properties.color ||feature.properties.base_height !==this.props.mapObject.mapData[index].properties.base_height ||feature.properties.height !==this.props.mapObject.mapData[index].properties.height  || feature.properties.opacity !== this.props.mapObject.mapData[index].properties.opacity || feature.properties.rgb !== this.props.mapObject.mapData[index].properties.rgb)) {
          if(typeof feature.properties.opacity === 'undefined') {
            feature.properties.opacity = 0.4;
          }
          if(feature.geometry.type==='Point') {
            var canvas = document.getElementById('wp_mapbox_gl_js_canvas_stage');
            var ctx = canvas.getContext('2d');
            var img  = document.getElementById('wp_mapbox_gl_js_canvas_img');
            if(!map.hasImage(feature.properties.marker_icon_url)) {
              img.onload = function() {
                canvas.width  = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0, img.width, img.height);
                map.addImage(feature.properties.marker_icon_url, ctx.getImageData(0, 0, img.width, img.height) );
                map.setLayoutProperty(feature.id,'icon-image',feature.properties.marker_icon_url)
                map.setLayoutProperty(feature.id,'icon-anchor',feature.properties.marker_icon_anchor)
              };
              img.src = feature.properties.marker_icon_url.split('-wp_mapbox_gl_js_sizing-')[0];
            } else {
              map.setLayoutProperty(feature.id,'icon-image',feature.properties.marker_icon_url)
              map.setLayoutProperty(feature.id,'icon-anchor',feature.properties.marker_icon_anchor)
            }
            if(nextProps.mapObject.controls.clusterMarkers) {
              map.setPaintProperty(feature.id,'icon-opacity',0)
            }
          }
          if(feature.geometry.type==='Polygon') {
            if (feature.fillType === 'extrusion') {
              if (typeof feature.properties.height === 'string' || typeof feature.properties.base_height === 'string') {
                feature.properties.height = parseInt(feature.properties.height);
                feature.properties.base_height = parseInt(feature.properties.base_height);
              }

              map.setPaintProperty(feature.id, 'fill-extrusion-height', feature.properties.height);
              map.setPaintProperty(feature.id, 'fill-extrusion-base', feature.properties.base_height);
              map.setPaintProperty(feature.id, 'fill-extrusion-color', feature.properties.color);
              map.setPaintProperty(feature.id, 'fill-extrusion-opacity', feature.properties.opacity);
            } else {
              map.setPaintProperty(feature.id, 'fill-color',feature.properties.color)
              map.setPaintProperty(feature.id, 'fill-opacity',feature.properties.opacity)
            }
          }
          if(feature.geometry.type==='LineString') {
            map.setPaintProperty(feature.id,'line-color',feature.properties.color)
            map.setPaintProperty(feature.id,'line-opacity',feature.properties.opacity)
          }
        }

        if(typeof map.getSource(feature.id)==='undefined') {
          if(typeof feature.properties.opacity === 'undefined') {
            feature.properties.opacity = 0.4;
          }
          map.addSource(feature.id, {
            "type": "geojson",
            "data": featureCollection
          });
          if(feature.geometry.type==='Point') {
            // Add the icon image, then add layer
            if(this.state.loadedIcons.indexOf(feature.properties.marker_icon_url)===-1 && !map.hasImage(feature.properties.marker_icon_url)) {
              // This prevents from ignoring icon on quick first load
              var loadedIcons = JSON.parse(JSON.stringify(this.state.loadedIcons));
              loadedIcons.push(feature.properties.marker_icon_url);
              this.setState({loadedIcons});

              var canvas = document.getElementById('wp_mapbox_gl_js_canvas_stage');
              var ctx = canvas.getContext('2d');
              var img = document.getElementById('wp_mapbox_gl_js_canvas_img_stage');
              img.onload = function() {
                var sizingOfImage = img.dataset.marker_icon_url.split('-wp_mapbox_gl_js_sizing-')[1];
                var widthHeight = sizingOfImage ? sizingOfImage.split('-') : [100,100];
                canvas.width  = widthHeight[0];
                canvas.height = widthHeight[1];
                ctx.drawImage(img, 0, 0, widthHeight[0], widthHeight[1]);
                map.addImage(img.dataset.marker_icon_url, ctx.getImageData(0, 0, widthHeight[0], widthHeight[1]) );

                var lineLayer = map.addLayer({
                  'id': img.dataset.feature_id,
                  'type': 'symbol',
                  'source' : img.dataset.feature_id,
                  'layout': {
                    'icon-image': img.dataset.marker_icon_url,
                    'icon-anchor' : feature.properties.marker_icon_anchor,
                    'icon-size' : 0.2
                  },
                  'paint' : {
                    'icon-opacity' : nextProps.mapObject.controls.clusterMarkers ? 0 : 1
                  }
                })

              };
              setTimeout(function() {
                img.src = feature.properties.marker_icon_url.split('-wp_mapbox_gl_js_sizing-')[0];
                img.setAttribute('data-marker_icon_url', feature.properties.marker_icon_url);
                img.setAttribute('data-feature_id', feature.id);
              },1000*index);

              // Open popup if set to open on load
              if(feature.properties.popup_open) {
                var popup = new mapboxgl.Popup({
                  offset : 20
                });

                let popupHTML =
                    '<div>'+
                      '<div>'+feature.properties.description+'</div>'+
                      '<div style="display:flex;margin-left:-7px;position:absolute;margin-top:50px;">'+
                        '<button id="changePopupContent" class="button" data-featureid="'+feature.id+'"><i class="dashicons dashicons-edit"></i></button>'+ '<br>' +
                        '<button id="deleteFeatureFromPopup" class="button" data-featureid="'+feature.id+'"><i class="dashicons dashicons-trash"></i></button>'+
                      '</div>'+
                    '</div>';

                popup.setLngLat({lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0]})
                  .setHTML(popupHTML).addTo(map);

                this.setState({popup})
              }
            } else {
              var lineLayer = map.addLayer({
                'id': feature.id,
                'type': 'symbol',
                'source' : feature.id,
                'layout': {
                  'icon-image': feature.properties.marker_icon_url,
                  'icon-anchor' : feature.properties.marker_icon_anchor,
                  'icon-size' : 0.2
                },
                'paint' : {
                  'icon-opacity' : nextProps.mapObject.controls.clusterMarkers ? 0 : 1
                }
              })
            }
          } else if(feature.geometry.type==='Polygon') {
            // Check for regular fill or fill extrusion
            if (typeof feature.properties.base_height !== 'undefined' || typeof feature.properties.height !== 'undefined' || typeof feature.properties.level !== 'undefined') {
              if (typeof feature.properties.base_height === 'string' || typeof feature.properties.height === 'string') {
                feature.properties.base_height = parseInt(feature.properties.base_height);
                feature.properties.height = parseInt(feature.properties.height);
              }

              var lineLayer = map.addLayer({
                'id': feature.id,
                'type': 'fill-extrusion',
                'source' : feature.id,
                'paint': {
                  'fill-extrusion-color': feature.properties.color,
                  'fill-extrusion-height': feature.properties.height,
                  'fill-extrusion-base': feature.properties.base_height,
                  'fill-extrusion-opacity': feature.properties.opacity
                }
              });
            } else {
              var lineLayer = map.addLayer({
                'id': feature.id,
                'type': 'fill',
                'source' : feature.id,
                'paint': {
                  'fill-color' : feature.properties.color,
                  'fill-opacity' : feature.properties.opacity
                }
              })
            }
          } else if(feature.geometry.type==='LineString') {
            var lineLayer = map.addLayer({
              'id': feature.id,
              'type': 'line',
              'source' : feature.id,
              'paint': {
                'line-color' : feature.properties.color
              }
            })
          }
          var that = this;

          setTimeout(function() {
            map.on('click',feature.id,function(e) {
              if(that.state.popup) {
                that.state.popup.remove();
              }
              if(e.features[0].geometry.type==='Point') {
                // map.flyTo({
                //   center: e.features[0].geometry.coordinates,
                //   zoom : map.getZoom()<7 ? 7 : map.getZoom()
                // });

                var popup = new mapboxgl.Popup({
                  offset : 20
                })

                let popupHTML =
                  '<div>'+
                    '<div>'+e.features[0].properties.description+'</div>'+
                    '<div style="display:flex;margin-left:-7px;position:absolute;margin-top:50px;">'+
                      '<button id="changePopupContent" class="button" data-featureid="'+e.features[0].layer.id+'"><i class="dashicons dashicons-edit"></i></button>'+ '<br>' +
                      '<button id="deleteFeatureFromPopup" class="button" data-featureid="'+e.features[0].layer.id+'"><i class="dashicons dashicons-trash"></i></button>'+
                    '</div>'+
                  '</div>';

                popup.setLngLat({lat: e.features[0].geometry.coordinates[1], lng: e.features[0].geometry.coordinates[0]})
                  .setHTML(popupHTML).addTo(map);

                this.setState({popup})
              }
              this.props.dispatch(selectGeometry(e.features[0].layer.id))
            }.bind(that))
          },100)
        } else {
          // popup.remove();
          // this.state.popup.addTo(map);
          map.getSource(feature.id).setData(featureCollection);
        }
      }.bind(this));
    }
  }

  render() {


    return (
      <div>
        <div id="wp_mapbox_gl_js_map"></div>
        <div className="wp_mapbox_gl_js_staging">
          <canvas id="wp_mapbox_gl_js_canvas_stage"></canvas>
          <img id="wp_mapbox_gl_js_canvas_img_stage"></img>
        </div>
        {this.state.drawingDirections
        ? <p
          className="wp_mapbox_gl_js_drawing-directions"
          dangerouslySetInnerHTML={{ __html: this.state.drawingDirections}} /> : false}
      </div>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map.js